export type RulesBlock = { kind: 'p'; text: string } | { kind: 'ul'; items: string[] };

export type RulesSection = {
  title: string;
  blocks: RulesBlock[];
};

export const RULES_CONTENT: RulesSection[] = [
  {
    title: '게임 개요',
    blocks: [
      {
        kind: 'p',
        text: '컴플레또는 1~100 숫자 타일을 자기 줄에 오름차순으로 채우는 정렬 게임입니다.',
      },
      {
        kind: 'ul',
        items: [
          '인원: 2~4명',
          '타일: 1~100, 각 1장씩 총 100장',
          '내 줄: 22칸 (좌→우 오름차순)',
          '목표: 내 줄 22칸을 모두 공개로 만들기',
        ],
      },
    ],
  },
  {
    title: '게임 시작',
    blocks: [
      {
        kind: 'ul',
        items: [
          '더미에서 17장을 무작위로 받아 비공개로 늘어놓습니다.',
          '추가로 5장을 공개로 받아, 좌→우 오름차순이 되도록 적절한 자리에 끼워 넣습니다.',
          '결과: 22칸 중 5칸 공개, 17칸 비공개. 공개 타일은 항상 오름차순입니다.',
        ],
      },
    ],
  },
  {
    title: '내 차례에 할 일',
    blocks: [
      { kind: 'p', text: '액션 A 또는 B 중 하나를 선택합니다.' },
      {
        kind: 'ul',
        items: [
          '액션 A — 1장 가져오기: 더미에서 뽑거나, 공개 풀에서 한 장을 골라 내 줄의 알맞은 자리(좌측 공개 < N < 우측 공개)에 끼워 넣습니다. 그 자리에 있던 비공개 타일은 더미로 돌아갑니다.',
          '액션 B — 비공개 타일 위치 바꾸기: 내 줄의 비공개 타일 1개를 다른 자리로 옮깁니다. (공개 타일은 움직일 수 없으며, 새로 공개되는 타일은 없습니다.)',
          'A-1에서 뽑은 타일을 어디에도 못 놓으면 공개 풀로 보내고 차례가 끝납니다.',
        ],
      },
    ],
  },
  {
    title: '연속 보너스',
    blocks: [
      {
        kind: 'p',
        text: '액션 A로 방금 놓은 공개 타일이 인접한 좌/우 공개 타일과 ±1 차이라면, 한 번 더 차례를 이어갑니다.',
      },
      {
        kind: 'ul',
        items: [
          '보너스 차례에서도 액션 A 또는 B 중 자유롭게 선택할 수 있습니다.',
          '연속 ±1이 계속 발생하면 보너스가 무한 체인됩니다.',
          '액션 B나 공개 풀로 버린 경우에는 보너스가 없습니다.',
        ],
      },
    ],
  },
  {
    title: '숫자 회전',
    blocks: [
      {
        kind: 'p',
        text: '180° 돌렸을 때 1~100의 다른 숫자가 되는 타일은, 내 줄에 놓는 순간 둘 중 하나로 결정해 사용할 수 있습니다. 한 번 결정하면 그 타일은 그 숫자로 고정됩니다.',
      },
      {
        kind: 'ul',
        items: [
          '회전 가능한 자릿수: 0, 1, 6, 8, 9 (2·3·4·5·7은 회전 불가)',
          '회전 페어: 6↔9, 16↔91, 18↔81, 19↔61, 66↔99, 68↔89, 86↔98',
          '회전해도 자기 자신: 1, 8, 11, 69, 88, 96',
        ],
      },
    ],
  },
  {
    title: '승리 조건',
    blocks: [
      {
        kind: 'p',
        text: '누구든 자기 줄 22칸을 모두 공개하는 순간 게임이 즉시 종료되고 그 플레이어가 우승합니다.',
      },
      {
        kind: 'p',
        text: '룰 제약상 22칸이 모두 공개되면 자동으로 좌→우 오름차순이 됩니다. 무승부는 없습니다.',
      },
    ],
  },
];
